import { css } from '@emotion/react'
import {
  cssVar,
  FontWeight,
  Size,
  Spacing,
  ThemedColors,
  Transition,
} from '@opallabs/gem'

export const inputContainer = ({
  hasError,
  isOpen,
}: {
  hasError?: boolean
  isOpen?: boolean
}) =>
  css({
    alignItems: 'center',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: Size.Rounding,
    boxSizing: 'border-box',
    display: 'flex',
    flexFlow: 'row nowrap',
    height: Spacing.XS * 9,
    padding: Spacing.S,
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: cssVar(ThemedColors.Surface2),
    borderColor: isOpen
      ? cssVar(ThemedColors.StrokePrimary2)
      : hasError
        ? cssVar(ThemedColors.Error1)
        : cssVar(ThemedColors.StrokeSecondary2),
    ...Transition(['border-color', 'box-shadow', 'opacity']),

    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.7,
      backgroundColor: cssVar(ThemedColors.Surface3),
    },
    '&:focused': {
      borderColor: cssVar(ThemedColors.StrokePrimary2),
    },
    // used for hover/active overlays on top of the button’s base color
    '&::before': {
      borderRadius: 'inherit',
      content: '""',
      display: 'flex',
      // `-1` compensates for `borderWidth: 1`; without it `::before` is inset
      // by 1 pixel from the button’s outer edge
      inset: -1,
      position: 'absolute',
      zIndex: 0,
      ...Transition(['background-color']),
    },

    '@media (prefers-contrast: more)': {
      fontWeight: FontWeight.Semibold,
    },

    '@media (prefers-reduced-motion: reduced)': {
      transition: 'none',
      '&::before': {
        transition: 'none',
      },
    },
  })

export const selectionContent = css({
  flex: 1,
  textAlign: 'left',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  columnGap: Spacing.XS,
})
